module.exports = __webpack_public_path__ + "img/2.-潭柘寺柏柿如意（马晓燕-摄）.3fb61cae.jpg";